import React from 'react';
import { observer } from 'mobx-react';

import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Form } from 'libs/forms/index';
import { Trans } from 'react-i18next';

import { ModeratorFormAppManager } from 'apps/channel/moderatorForm/appManager';

@observer
export class ModeratorForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new ModeratorFormAppManager(null, modalStore.props);
  }

  render() {
    const { moderatorFormApp } = this.appManager;
    const { form } = moderatorFormApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={moderatorFormApp.Post}
          noBorder={true}
          padding='0'
        />
      </>
    );
  }
}
